import { StatusEnum } from '@common/constants';

export function isPending(status: string): boolean {
  return status === StatusEnum.Pending;
}
